(function () {
  var API_VERSION = "2026-04";
  var MUTATION =
    "mutation customerCreate($input: CustomerCreateInput!) {" +
    "  customerCreate(input: $input) {" +
    "    customer { email acceptsMarketing }" +
    "    customerUserErrors { field message code }" +
    "  }" +
    "}";

  function generatePassword() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID() + "Aa1!";
    }
    return Math.random().toString(36).slice(2) + Date.now().toString(36) + "Aa1!";
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  document.querySelectorAll("[data-newsletter-form]").forEach(function (form) {
    var msg = form.querySelector("[data-newsletter-msg]");
    var emailInput = form.querySelector("[data-newsletter-email]");
    var btn = form.querySelector("[data-newsletter-btn]");
    var icon = form.querySelector("[data-newsletter-icon]");
    var spinner = form.querySelector("[data-newsletter-spinner]");
    var inputWrap = form.querySelector("[data-newsletter-input]");
    var configEl = form.querySelector("[data-newsletter-config]");

    var config = {};
    if (configEl) {
      try {
        config = JSON.parse(configEl.textContent || "{}");
      } catch (err) {
        config = {};
      }
    }

    function showMessage(text) {
      msg.textContent = text;
      msg.classList.remove("hidden");
    }

    function showSuccess() {
      inputWrap.classList.add("hidden");
      showMessage("Thanks for signing up!");
    }

    function setLoading(isLoading) {
      btn.disabled = isLoading;
      emailInput.disabled = isLoading;
      icon.classList.toggle("hidden", isLoading);
      spinner.classList.toggle("hidden", !isLoading);
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      if (!config.shop || !config.token) {
        showMessage(
          "Newsletter is not configured. Add a Storefront API token in Theme settings."
        );
        return;
      }

      var email = (emailInput.value || "").trim();
      if (!isValidEmail(email)) {
        showMessage("Please enter a valid email address.");
        return;
      }

      msg.classList.add("hidden");
      msg.textContent = "";
      setLoading(true);

      fetch("https://" + config.shop + "/api/" + API_VERSION + "/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": config.token,
          Accept: "application/json",
        },
        body: JSON.stringify({
          query: MUTATION,
          variables: {
            input: {
              email: email,
              password: generatePassword(),
              acceptsMarketing: true,
            },
          },
        }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (json) {
          var payload = json && json.data && json.data.customerCreate;
          var errors = (payload && payload.customerUserErrors) || [];

          if (payload && payload.customer) {
            showSuccess();
            return;
          }

          var alreadyExists = errors.some(function (err) {
            return (
              err.code === "TAKEN" ||
              err.code === "CUSTOMER_DISABLED" ||
              (err.message || "").toLowerCase().indexOf("already") !== -1
            );
          });

          if (alreadyExists) {
            showSuccess();
            return;
          }

          var firstMessage = errors[0] && errors[0].message;
          showMessage(firstMessage || "Something went wrong. Please try again.");
        })
        .catch(function () {
          showMessage("Something went wrong. Please try again.");
        })
        .finally(function () {
          setLoading(false);
        });
    });
  });
})();
